import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.title',
    defaultMessage: 'Register Incident',
  },
  selectTasks: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.selectTasks',
    defaultMessage: '1. Select affected tasks',
  },
  selectReporter: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.selectReporter',
    defaultMessage: '2. Select reporter',
  },
  selectProcessArea: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.selectProcessArea',
    defaultMessage: '3. (Optionally) Select process area',
  },
  selectIncidentType: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.selectIncidentType',
    defaultMessage: '4. Select incident type',
  },
  comment: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.comment',
    defaultMessage: '5. (Optionally) Leave comment',
  },
  registerRetake: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.registerRetake',
    defaultMessage: 'Retake',
  },
  copySourceFiles: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.copySourceFiles',
    defaultMessage: 'Copy source files',
  },
  submit: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.submit',
    defaultMessage: 'Register',
  },
  loading: {
    id: 'containers.SupplierTaskPage.components.IncidentDialog.loading',
    defaultMessage: 'Loading',
  }
  
})
